import React, { useState } from 'react';
import { Layout, Typography, Space, Alert, Spin } from 'antd';
import { ThunderboltOutlined, BarChartOutlined } from '@ant-design/icons';
import SimulationForm from './components/SimulationForm';
import './App.css';

const { Header, Content } = Layout;
const { Title, Text } = Typography;

function App() {
  const [isRunning, setIsRunning] = useState(false);

  const handleSimulationStart = () => {
    setIsRunning(true);
  };

  const handleSimulationComplete = (result) => {
    setIsRunning(false);
  };

  return (
    <Layout className="app-layout">
      <Header className="app-header">
        <div className="header-content">
          <Space align="center">
            <ThunderboltOutlined style={{ fontSize: '24px', color: '#1890ff' }} />
            <Title level={3} style={{ color: 'white', margin: 0 }}>
              Lumia Parlay Simulation
            </Title>
          </Space>
          <Text style={{ color: 'rgba(255, 255, 255, 0.85)' }}>
            Betting system simulator with customizable parameters
          </Text>
        </div>
      </Header>

      <Content className="app-content">
        <div className="content-container">
          {isRunning && (
            <Alert
              message="Simulation is running"
              description={
                <Space>
                  <Spin size="small" />
                  Please wait. This may take several minutes...
                </Space>
              }
              type="info"
              showIcon
              style={{ marginBottom: 16 }}
            />
          )}

          <SimulationForm
            onSimulationStart={handleSimulationStart}
            onSimulationComplete={handleSimulationComplete}
          />

          {!isRunning && (
            <Alert
              message="Welcome to Lumia Parlay Simulation!"
              description={
                <div>
                  <p>This tool allows you to simulate the Lumia Parlay betting system with various parameters.</p>
                  <p><strong>Features:</strong></p>
                  <ul>
                    <li>Game parameter configuration (odds, probabilities, limits)</li>
                    <li>Pool and fund balance management</li>
                    <li>Pool depletion protection system</li>
                    <li>Detailed statistics and result visualization</li>
                    <li>Money flow analysis and House Edge</li>
                  </ul>
                  <p>Start by configuring the parameters above and run the simulation!</p>
                </div>
              }
              type="info"
              showIcon
              icon={<BarChartOutlined />}
              style={{ marginTop: 16 }}
            />
          )}
        </div>
      </Content>
    </Layout>
  );
}

export default App;
